class XpBar {

    animate(xpRequirements, playerXpInfo, xpToAdd) {

        let currentXp = playerXpInfo['xp'];
        let currentLevel = playerXpInfo['level'];

        let levelName = playerXpInfo['activeRowInfo']['levelName'];
        let nextLevelName = playerXpInfo['activeRowInfo']['nextLevelName'];
        let nextLevelNameWhenLevelUp = playerXpInfo['activeRowInfo']['nextLevelNameWhenLevelUp'];


        let progressValue = currentXp;
        let nextLevelRequirement = xpRequirements['current'];

        let xpStep = this.getXpStep(xpToAdd);
        let xpAdded = 0;

        this.setLevels(levelName, nextLevelName, nextLevelRequirement);


        if(currentXp !== null) {
            this.setXpBar(currentXp, nextLevelRequirement);
        }
        

        const interval = setInterval(
            () => {

                if(progressValue >= (nextLevelRequirement - xpStep))
                {
                    xpStep = this.getXpStep(xpToAdd);
                    nextLevelRequirement = xpRequirements['next'];
                    currentXp = 0; 
                    progressValue = 0;
                    currentLevel += 1;
                    this.setLevels(nextLevelName, nextLevelNameWhenLevelUp, nextLevelRequirement);
                    xpAdded += xpStep;
                }

                if(xpAdded >= xpToAdd) { clearInterval(interval); return;} 


                progressValue = Number(progressValue) + xpStep;
                this.setXpBar(progressValue, nextLevelRequirement);

                xpAdded += xpStep;
            }, 
            30
        );


        const animatedNumberText = xpToAdd + " " + localizedTexts.games.xp.xpShortcut;
        new AnimatedNumber($('#xp-level-bar .xp-bar .xp-info-wrapper'), "xp-amount-to-add-span", animatedNumberText)
            .animate(
                {
                    top: "-50px",
                    right: "-15px",
                },
            );
    }

    setXpBar(value, nextLevelRequirement) {

        const barWidth = this.getProgressBarPercentage(value, nextLevelRequirement);
        $('.xp-bar .bar-fill').css('width', barWidth + '%');
        $('.xp-bar .xp-info').text(value + '/' + nextLevelRequirement);
    }

    setLevels(levelName, nextLevelName, nextLevelRequirement) {
        $('#xp-level-bar .xp-level .current-level').text(levelName);
        $('#xp-level-bar .xp-level .next-level').text(nextLevelName);

        this.setXpBar(0, nextLevelRequirement);
    }

    getProgressBarPercentage(xp, from) {
        return Math.round(Number(xp) / Number(from) * 100);
    }

    getXpStep(xpToAdd) {

        if(xpToAdd >= 1000 && xpToAdd % 100 === 0) { return 100; }
        
        if(xpToAdd >= 100 && xpToAdd % 10 === 0) { return 10; }

        return 1;
    }

}